export enum StoreEnum {
  UserStore = 'userStore',
  AuthStore = 'authStore',
  BeneficiaryStore = 'beneficiaryStore',
  UiStore = 'uiStore'
}
